import { GuidService } from 'ui-components/services/guid-service';
import * as ConnectActions from '../../store/shipstation-connect/ss-connect.actions';
import * as PrintSettingActions from '../../store/print-settings/print-settings.actions';

const refreshWorkstationsData = () => ConnectActions.getWorkstationsRequest();

export const WorkstationsEvents = [
  {
    eventName: 'connect:workstation:activated',
    actionToDispatch: () => refreshWorkstationsData(),
  },
  {
    eventName: 'connect:workstation:deactivated',
    actionToDispatch: ({ workstationId }) => [
      refreshWorkstationsData(),
      PrintSettingActions.clearPrintSettingsWithWorkstation(workstationId),
      ConnectActions.clearDevicesForWorkstation(workstationId),
    ],
  },
  {
    eventName: 'pusher:member_removed',
    actionToDispatch: ({ id }) => {
      // Pusher channel members that are pure guids are workstations,
      // browser clients are `username+guid`
      if (GuidService.isGuid(id)) {
        return [ConnectActions.handleWorkstationRemovedMessage(id)];
      }

      return [];
    },
  },
];
